module.exports = __webpack_public_path__ + "img/SKMJ_mach2.ce3a1202.png";